import cryptoRandomString from "crypto-random-string";

export const uuid = (): string =>
  Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);

export const generateCryptoRandomString = (character: number): string =>
  cryptoRandomString({ length: character, type: "alphanumeric" });
